// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prompt-rollback[data-v-7c4b6c01]{margin:0}.prompt-rollback[data-v-7c4b6c01] .card-actions{display:grid}.yaml-editor[data-v-7c4b6c01]{max-height:70vh}.yaml-editor[data-v-7c4b6c01].root{max-height:65vh}.diff[data-v-7c4b6c01]:disabled{border:none}.diff[data-v-7c4b6c01]:focus{background:transparent;box-shadow:none}[data-v-7c4b6c01] .card-body{max-height:calc(95vh - 135px);overflow:hidden}", ""]);
// Exports
module.exports = exports;
